module.exports = __webpack_public_path__ + "img/Follow_the_Instructions.3b0f6feb.png";